class QuantitySelector {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._minusButton = this._elem.querySelector('[data-minus]')
        this._plusButton = this._elem.querySelector('[data-plus]')
        this._input = this._elem.querySelector('[data-input]')
        this._min = 0
        this._max = Infinity
    }

    onInit () {
        let instance = this
        this.doLimits()

        this._minusButton.addEventListener('click', (e) => {
            this.doLimits()
            e.preventDefault()
            if ((parseInt(this._input.value) - 1) < this._min) return false
            this._input.value = parseInt(this._input.value) - 1
            let event = document.createEvent('HTMLEvents')
            event.initEvent('input', true, false)
            this._input.dispatchEvent(event)
        })

        this._plusButton.addEventListener('click', (e) => {
            this.doLimits()
            e.preventDefault()
            if ((parseInt(this._input.value) + 1) > this._max) return false
            this._input.value = parseInt(this._input.value) + 1
            let event = document.createEvent('HTMLEvents')
            event.initEvent('input', true, false)
            this._input.dispatchEvent(event)
        })

        this._input.addEventListener('input', function (e) {
            instance.doLimits()
            if (parseInt(this.value) <= instance._min) this.value = instance._min
            if (parseInt(this.value) >= instance._max) this.value = instance._max
            if (isNaN(parseInt(this.value))) this.value = instance._min
        })

        this._input.addEventListener('touchstart', (e) => {
            return false
        })
    }

    doLimits () {
        this._min = this._input.dataset.min ? parseInt(this._input.dataset.min) : 1
        this._max = this._input.dataset.max ? parseInt(this._input.dataset.max) : Infinity
    }
}

export default QuantitySelector



// WEBPACK FOOTER //
// ./src/scripts/components/QuantitySelector.js